import { z } from "zod";
import { idSchema, optionalText, pixKeyTypeSchema, requiredText } from "./common.js";
/**
 * Uma "pessoa" e o participante do rolê. Ela nasce como placeholder — so o nome
 * basta — e pode, depois, ser ligada a uma conta de verdade.
 */
export const createPersonSchema = z
    .object({
    displayName: requiredText(80, "nome"),
    pixKeyType: pixKeyTypeSchema.nullish(),
    pixKey: optionalText(140).nullable(),
    /** E-mail de uma conta existente, para ja nascer vinculada. */
    linkEmail: z.string().trim().toLowerCase().email().max(180).optional().or(z.literal("")),
})
    .refine((data) => !(data.pixKey && !data.pixKeyType), {
    message: "Escolha o tipo da chave Pix.",
    path: ["pixKeyType"],
});
export const updatePersonSchema = z
    .object({
    displayName: requiredText(80, "nome").optional(),
    pixKeyType: pixKeyTypeSchema.nullable().optional(),
    pixKey: optionalText(140).nullable(),
})
    .refine((data) => !(data.pixKey && !data.pixKeyType), {
    message: "Escolha o tipo da chave Pix.",
    path: ["pixKeyType"],
});
/** Vincula (ou corrige o vinculo de) um placeholder a uma conta real. */
export const linkPersonSchema = z.object({
    email: z.string().trim().toLowerCase().email({ message: "Informe um e-mail válido." }).max(180),
});
/** Junta dois cadastros duplicados. Tudo do `sourceId` passa para o `targetId`. */
export const mergePeopleSchema = z
    .object({
    sourceId: idSchema,
    targetId: idSchema,
})
    .refine((data) => data.sourceId !== data.targetId, {
    message: "Escolha duas pessoas diferentes.",
    path: ["sourceId"],
});
//# sourceMappingURL=person.js.map